import { Home, Hammer, Wrench, Construction } from "lucide-react";
import { PhotoSlot } from "@/components/site/PhotoSlot";
import { QuoteButton } from "@/components/site/Cta";
import { MaskLines, Reveal } from "@/components/site/Reveal";
import { PHOTOS } from "@/content/site";

const USES = [
  { icon: Home, t: "Roof replacement" }, { icon: Construction, t: "Construction" },
  { icon: Hammer, t: "Home repairs" }, { icon: Wrench, t: "Other work near your array" },
];

export const DetachReset = () => (
  <section id="detach-reset" data-testid="detach-section" className="relative overflow-hidden bg-[#0b0c0e] py-24 sm:py-32">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="relative overflow-hidden rounded-[32px] border border-white/10">
        <div className="absolute inset-0">
          <PhotoSlot src={PHOTOS.detach} alt="Texas home with a completed rooftop solar panel system by Solar Energy Doc" label="Detach & reset" className="h-full w-full" cover testId="detach-photo" />
        </div>
        <div className="absolute inset-0 bg-[#08090a]/80 lg:bg-transparent lg:bg-gradient-to-r lg:from-[#08090a] lg:via-[#08090a]/85 lg:to-[#08090a]/20" />
        <div className="relative grid gap-10 p-7 sm:p-12 lg:grid-cols-12 lg:p-16">
          <div className="lg:col-span-7">
            <Reveal className="flex items-center gap-3"><span className="h-px w-8 bg-amber-400/70" /><span className="eyebrow">Detach &amp; Reset</span></Reveal>
            <MaskLines lines={["Need your solar system", "removed and reinstalled?"]} className="mt-5 text-[1.6rem] leading-[1.12] sm:text-4xl lg:text-5xl font-semibold uppercase text-white" />
            <Reveal delay={0.1} as="p" className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-zinc-300">
              Whether you're replacing a roof, completing construction, repairing your home, or performing other work around your solar system, Solar Energy Doc provides professional solar detach and reset services.
            </Reveal>
            <div className="mt-9"><QuoteButton service="Detach & Reset" testId="detach-cta">Request a Detach &amp; Reset Quote</QuoteButton></div>
          </div>
          <ul className="lg:col-span-5 grid grid-cols-2 gap-3 self-end">
            {USES.map((u, i) => (
              <Reveal key={u.t} delay={i * 0.07} as="li" className="glass rounded-2xl p-5">
                <u.icon className="h-5 w-5 text-amber-400" />
                <p className="mt-6 text-sm font-semibold text-white">{u.t}</p>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
